import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Icons from '../layouts/Icons';

export default function ExploreBlockVideoBlock({ data, onClick }) {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, type: 'tween', ease: 'easeInOut' }}
        className="fixed bg-black bg-opacity-50 top-0 left-0 w-full h-screen 3xl:pt-[100px] pt-10
        md:pb-[100px] pb-10 z-100 px-4 flex justify-center items-center overflow-hidden">
        <div className="3xl:w-[1200px] w-[1000px] h-auto relative">
          <div>
            <div className="absolute top-6 right-6">
              <button
                type="button"
                onClick={onClick}
                className="h-[30px] w-[30px] bg-white flex justify-center items-center">
                <Icons
                  icon="close"
                  className="md:w-full md:h-[22px] h-[17px]"
                />
              </button>
            </div>
            <iframe
              src={data}
              title="about intro video"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              className="w-full h-full aspect-video"
            />
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
